import React from 'react';
import './MediaHero.css';

function MediaHero() {
  return (
    <section 
      className="media-hero" 
      id="media-hero"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/media-hero-bg.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#1a1a1a'
      }}
    >
      <div className="media-hero-overlay"></div>
      <div className="container">
        <div className="mediahero-content">
          <div className="mediahero-text">
            <h1 className="mediahero-title">Medios</h1>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MediaHero;
